export enum ListTypes {
    AirswebList = "AIRSWEBLIST",
    Hierarchy = "HIERARCHY"
}